<template>
  <v-card>
    <v-card-text class="text-xs-center headline secondary--text">Nova política de privacidade</v-card-text>
    <v-container fluid grid-list-md class="pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex xs8 align-self-center>
            <v-menu offset-y bottom transition="slide-y-transition" :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  v-on="on"
                  class="body-2 font-weight-regular grey--text text--darken-2"
                >Quem poderá ver a política de privacidade?</v-btn>
              </template>
              <v-card>
                <v-container fluid grid-list-xs class="pt-0">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="politicaModel.frentista"
                        label="Frentista"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-model="politicaModel.empresa"
                        label="Empresa"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="politicaModel.posto"
                        label="Posto"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-model="politicaModel.cliente"
                        label="Cliente"
                        color="primary"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-menu>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              maxlength="10"
              label="Versão"
              v-model="politicaModel.versao"
              hint="Usada para fins de controle"
              required
              :rules="[(v) => !!v || 'A versão é obrigatória']"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              outline
              v-model="politicaModel.texto"
              required
              label="Texto em HTML"
              :rules="[(v) => !!v || 'O texto da política de privacidade é obrigatório']"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-btn flat class="grey--text text--darken-2" @click="fechar()">VOLTAR</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat class="success--text" :loading="loading" @click="cadastrar()">CONFIRMAR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      politicaModel: {
        texto: null,
        versao: null,
        frentista: false,
        empresa: false,
        posto: false,
        cliente: false
      },
      valid: false
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    cadastrar () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('inserirPoliticaDePrivacidae', this.politicaModel).then(() => {
          this.$emit('info', 'As políticas de privacidade foram inseridas com sucesso')
          this.fechar()
        }).catch((error) => {
          this.$emit('error', error)
        })
      }
    },
    fechar () {
      this.$refs.form.reset()
      this.$emit('fechar')
    }
  }
}
</script>
